import { render, staticRenderFns } from "./PhoneNumberSetting.vue?vue&type=template&id=2f62d3ac&"
import script from "./PhoneNumberSetting.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports